import { useContext, useEffect, useRef } from 'react';
import DropdownMenu from './DropdownMenu';
import {
    StyledButton,
    StyledLabel,
} from '../StyledComponents/UserFormStyledComponents';
import {
    RefreshRates,
} from '../constants';
import { RefreshIcon } from '../Icons/Icons';
import { StateContext } from '../../Controllers/context/state';
import SearchDropdown from './SearchDropdown';
import { FilterContainer } from '../StyledComponents/AppStyledComponents';

const SortMenu = ({
    handleRefresh,
}) => {
    const {
        assets,
        refreshRate,
        setRefreshRate,
        selectedScreener,
        setSort,
        sort,
    } = useContext(StateContext);
    const searchRef = useRef(null);
    
    useEffect(() => {
        setRefreshRate(selectedScreener?.data?.refreshRate || null);
        setSort(selectedScreener?.data?.sort || sort);
    }, [selectedScreener])

    const handleSetRefreshRate = (e) => {
        const rate = e.target.value;
        if (rate === 'Off (Manual)') {
            setRefreshRate(null);
        } else {
            setRefreshRate(rate);
        }
    };

    const handleSubmit = (value) => {
        setSort((prevState) => ({
            ...prevState,
            correlationAsset: value,
            key: 'correlation',
        }));
    };

    return (
        <div>
            <FilterContainer>
                <DropdownMenu
                    label={RefreshRates.label}
                    options={RefreshRates.values}
                    handleChange={handleSetRefreshRate}
                    value={refreshRate}
                    disa
                />
                <StyledButton onClick={() => handleRefresh({ retry: true })}>Refresh Cards Displayed <RefreshIcon/></StyledButton>
                <StyledLabel style={{ width: '100%' }}>
                    Correlation Asset:
                </StyledLabel>
                <SearchDropdown
                    handleSubmit={handleSubmit}
                    options={assets}
                    placeholder={sort.correlationAsset}
                    position='right'
                    searchRef={searchRef}
                />
            </FilterContainer>
        </div>
    )
};

export default SortMenu;
